export interface StructuredJobPay {
  rate_min?: number | string | null;
  rate_max?: number | string | null;
  rate_type?: string | null;
}

type JobPostingSalary = {
  '@type': 'MonetaryAmount';
  currency: 'USD';
  value: {
    '@type': 'QuantitativeValue';
    unitText: 'HOUR' | 'DAY' | 'WEEK' | 'MONTH' | 'YEAR';
    minValue?: number;
    maxValue?: number;
  };
};

const unitTextForRateType = (
  rateType: unknown,
): JobPostingSalary['value']['unitText'] | null => {
  const normalized = typeof rateType === 'string' ? rateType.toLowerCase() : '';
  if (['hour', 'hourly', 'hr'].includes(normalized)) return 'HOUR';
  if (['day', 'daily'].includes(normalized)) return 'DAY';
  if (['week', 'weekly', 'weekly_salary'].includes(normalized)) return 'WEEK';
  if (['month', 'monthly'].includes(normalized)) return 'MONTH';
  if (['year', 'yearly', 'salary'].includes(normalized)) return 'YEAR';
  return null;
};

export const buildJobPostingSalary = (job: StructuredJobPay): JobPostingSalary | null => {
  const hasMinimum = job.rate_min !== null && job.rate_min !== undefined && job.rate_min !== '';
  const hasMaximum = job.rate_max !== null && job.rate_max !== undefined && job.rate_max !== '';
  if (!hasMinimum && !hasMaximum) return null;

  const minimum = hasMinimum ? Number(job.rate_min) : null;
  const maximum = hasMaximum ? Number(job.rate_max) : null;
  const suppliedBoundsAreValid = (
    (!hasMinimum || (Number.isFinite(minimum) && Number(minimum) > 0))
    && (!hasMaximum || (Number.isFinite(maximum) && Number(maximum) > 0))
    && !(hasMinimum && hasMaximum && Number(minimum) > Number(maximum))
  );
  const unitText = unitTextForRateType(job.rate_type);
  if (!suppliedBoundsAreValid || !unitText) return null;

  const value: JobPostingSalary['value'] = {
    '@type': 'QuantitativeValue',
    unitText,
  };
  if (hasMinimum) value.minValue = Number(minimum);
  if (hasMaximum) value.maxValue = Number(maximum);

  return {
    '@type': 'MonetaryAmount',
    currency: 'USD',
    value,
  };
};

export { unitTextForRateType };
